import { createRouter, createWebHistory } from 'vue-router'

import Home from './components/Home.vue';
import About from './components/About.vue';
import CityMap from './components/CityMap.vue';
import PartnerView from './components/PartnerView.vue';
import Contact from './components/Contact.vue';
import PrivacyPolicy from './components/PrivacyPolicy.vue';

const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/', redirect: '/home' },
    { path: '/home', name: 'home', component: Home },
    { path: '/about', name: 'about', component: About },
    { path: '/citymap', name: 'citymap', component: CityMap},
    { path: '/partner/:slug', name: 'partner', component: PartnerView},
    { path: '/contact', name: 'contact', component: Contact},
    { path: '/privacypolicy', name: 'privacypolicy', component: PrivacyPolicy }
  ]
});

export default router;